/** Foreign postal codes are alphanumeric ('SW1A 1AA' -> 'SW1A1AA') and must survive into the API payload. */
export function normalizeForeignPostalCode(zipCode: string | null | undefined): string | null {
  const normalized = zipCode?.replace(/\W/g, '') ?? '';
  return normalized || null;
}
